const clean = (value) => String(value || "").replace(/\s+/g, " ").trim();

const roleKey = (row) =>
  `${row.englishName}|${row.companyName}|${row.companyRole}`.toLowerCase();

export const normalizeFwdRelatedPersons = (rows) => {
  const seen = new Set();
  const normalized = [];

  (rows || []).forEach((row) => {
    const englishName = clean(row?.englishName);
    const chineseName = clean(row?.chineseName);
    const companyName = clean(row?.companyName);
    const companyRole = clean(row?.companyRole);
    if (!englishName || !companyName || !companyRole) return;

    const next = { englishName, chineseName, companyName, companyRole };
    const key = roleKey(next);
    if (seen.has(key)) return;
    seen.add(key);
    normalized.push(next);
  });

  return normalized.sort(
    (a, b) =>
      a.englishName.localeCompare(b.englishName) ||
      a.companyName.localeCompare(b.companyName) ||
      a.companyRole.localeCompare(b.companyRole)
  );
};

export const validateFwdRelatedPersons = (rows) => {
  const seen = new Set();

  for (const row of rows || []) {
    const englishName = clean(row?.englishName);
    const companyName = clean(row?.companyName);
    const companyRole = clean(row?.companyRole);
    if (!englishName) return "English name is required";
    if (!companyName) return "Company name is required";
    if (!companyRole) return "Company role is required";

    const key = roleKey({ englishName, companyName, companyRole });
    if (seen.has(key)) return `Duplicate related person: ${englishName}`;
    seen.add(key);
  }

  return null;
};
